export const Experience = [
  {
    title: "May 2022-May 2025",
    cardTitle: "CS Club President",
    cardSubtitle: "Lone Star College Cyfair",
    cardDetailedText:
      "Led a 275+ member organization, increasing membership by 20%. Hosted workshops on Git, web development, and computer engineering for 50+ students. Coordinated 4 competitions and collaborated on 3+ Hackathons and VEX competitions.",
  },
  {
    title: "December 2022 - February 2025",
    cardTitle: "Senior Front-End Engineer",
    cardSubtitle: "Incarnate Editors — Contract/Remote",
    cardDetailedText:
      "Redesigned mobile UI with TailwindCSS driving a 20% increase in mobile traffic. Architected a 40+ node user flow diagram and built a full-stack data modeling app using React, Firebase, and Electron visualizing 100+ data entries.",
  },
  {
    title: "September 2021 - May 2022",
    cardTitle: "Computer Science Club Historian",
    cardSubtitle: "Mayde Creek High School",
    cardDetailedText:
      "Competed in several competitions where I flexed my programming skills and won 13th to last place. I also competed in Cyber Patriot where I learned about Linux and how bad Window's Security is by default.",
  },
];
